module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "ProfileSubordinate"
  }, [_c('div', {
    staticClass: "table table--profiles"
  }, [_c('h2', {
    staticClass: "section--title",
    staticStyle: {
      "margin": "0 0 1em 0"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.index.title))]), _vm._v(" "), (_vm.addButton) ? _c('md-button', {
    staticClass: "md-icon-button md-raised button",
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addProfile')
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _c('md-button', {
    staticClass: "md-icon-button md-raised button-remove",
    nativeOn: {
      "click": function($event) {
        _vm.removeRoles($event)
      }
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('md-table-card', {
    staticClass: "table--wrap"
  }, [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-by": "name"
    },
    on: {
      "sort": _vm.onSort
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "td-sort-name",
    attrs: {
      "md-sort-by": "name"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.index.fields.name))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.index.fields.actions))])], 1)], 1), _vm._v(" "), _c('md-table-body', [_vm._l((_vm.roles), function(row, rowIndex) {
    return _c('md-table-row', {
      key: rowIndex,
      attrs: {
        "md-item": row
      }
    }, [_c('md-table-cell', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(row.display_name))])]), _vm._v(" "), _c('td', {
      staticClass: "md-table-cell actions md-has-action"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_c('md-icon', {
      staticClass: "icon-edit raised",
      nativeOn: {
        "click": function($event) {
          _vm.openDialog('edit', row, rowIndex)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('md-icon', {
      staticClass: "icon-delete raised",
      nativeOn: {
        "click": function($event) {
          _vm.remove(row, rowIndex)
        }
      }
    }, [_vm._v("delete")])], 1)])], 1)
  }), _vm._v(" "), (_vm.roles.length == 0) ? _c('md-table-row', [_c('md-table-cell', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.translate.pages.role_profiles.index.no_records) + "\n                        ")])], 1) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "addProfile",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.add.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "profile_suggestion"
    }
  }, [_vm._v("Sugerencia de Nombre:")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "id": "profile_suggestion"
    },
    on: {
      "change": function($event) {
        _vm.setSuggestionName(_vm.newProfile.sname)
      }
    },
    model: {
      value: (_vm.newProfile.sname),
      callback: function($$v) {
        _vm.newProfile.sname = $$v
      },
      expression: "newProfile.sname"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "Prestador"
    }
  }, [_vm._v("Prestador")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Asistente"
    }
  }, [_vm._v("Asistente")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Secretaria"
    }
  }, [_vm._v("Secretaria/o")])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.name.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.role_profiles.add.fields.name))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.newProfile.name),
      callback: function($$v) {
        _vm.newProfile.name = $$v
      },
      expression: "newProfile.name"
    }
  }), _vm._v(" "), (_vm.errors.name.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.name.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex": "50"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.add.fields.permissions))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "selectAll",
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex": "50"
    },
    nativeOn: {
      "click": function($event) {
        _vm.selectAll($event)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.translate.pages.role_profiles.add.fields.select_all))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "multiple checkbox-list"
  }, [_c('div', {
    staticClass: "select"
  }, _vm._l((_vm.group_menu), function(menu, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _vm._l((menu.perms), function(permission) {
      return _c('md-checkbox', {
        key: permission.id,
        staticClass: "option",
        on: {
          "change": function($event) {
            _vm.onChosen($event, permission.id)
          }
        },
        model: {
          value: (permission.checked),
          callback: function($$v) {
            permission.checked = $$v
          },
          expression: "permission.checked"
        }
      }, [_vm._v(_vm._s(permission.display_name))])
    })], 2)
  }))])]), _vm._v(" "), _c('label', {
    staticClass: "subtitle",
    class: {
      error: _vm.errors.group_menu.invalid
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.add.fields.select_permissions_profile))])], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary md-size sm-size btn--cancel",
    staticStyle: {
      "padding": "0 15px !important"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('addProfile')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.actions.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "float-r md-primary md-size sm-size btn--blue",
    staticStyle: {
      "padding": "0 15px !important"
    },
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('addProfile', true)
      }
    }
  }, [_vm._v("Agregar")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "edit",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.edit.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.name.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.role_profiles.edit.fields.name))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentProfile.display_name),
      callback: function($$v) {
        _vm.currentProfile.display_name = $$v
      },
      expression: "currentProfile.display_name"
    }
  }), _vm._v(" "), (_vm.errors.name.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.name.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex": "50"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.edit.fields.permissions))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "selectAll",
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex": "50"
    },
    nativeOn: {
      "click": function($event) {
        _vm.selectAll($event)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.translate.pages.role_profiles.edit.fields.select_all))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "multiple checkbox-list"
  }, [_c('div', {
    staticClass: "select"
  }, _vm._l((_vm.group_menu), function(menu, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _vm._l((menu.perms), function(permission) {
      return _c('md-checkbox', {
        key: permission.id,
        staticClass: "option",
        on: {
          "change": function($event) {
            _vm.onChosen($event, permission.id, true)
          }
        },
        model: {
          value: (permission.checked),
          callback: function($$v) {
            permission.checked = $$v
          },
          expression: "permission.checked"
        }
      }, [_vm._v(_vm._s(permission.display_name))])
    })], 2)
  }))])]), _vm._v(" "), _c('label', {
    staticClass: "subtitle",
    class: {
      error: _vm.errors.group_menu.invalid
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.role_profiles.edit.fields.select_permissions_profile))])], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "md-primary btn--cancel",
    staticStyle: {
      "padding": "0 5px !important"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.actions.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary btn--blue",
    staticStyle: {
      "padding": "0 5px !important"
    },
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit', true)
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7d98af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Subordinate/Profile.vue
// module id = 689
// module chunks = 1